import { createSlice } from '@reduxjs/toolkit';

const impersonation = createSlice({
  name: 'impersonation',
  initialState: {
    token: null,
    uuid: null,
    data: null,
    provider: null,
    locations: null,
  },
  reducers: {
    impersonationRequest(state) {
      state.isLoading = true;
    },
    impersonationSuccess(state, { payload }) {
      return payload.data;
    },
    impersonationFailure(state) {
      state.isLoading = false;
    },
    userImpersonationRequest() {},
    userImpersonationSuccess(state, { payload }) {
      return {
        ...state,
        ...payload.data,
        providerUsers: payload.data.providerUsers?.[0],
      };
    },
    userImpersonationFailure() {},
    providerImpersonationRequest() {},
    providerImpersonationSuccess(state, { payload }) {
      state.provider = payload.data;
    },
    providerImpersonationFailure() {},
    setImpersonationLocations(state, { payload }) {
      state.locations = payload;
    },
    clearImpersonation() {
      return {
        token: null,
        uuid: null,
      };
    },
  },
});

const { actions, reducer } = impersonation;

export const {
  impersonationRequest,
  impersonationSuccess,
  impersonationFailure,
  clearImpersonation,
  userImpersonationRequest,
  userImpersonationSuccess,
  userImpersonationFailure,
  providerImpersonationRequest,
  providerImpersonationSuccess,
  providerImpersonationFailure,
  setImpersonationLocations,
} = actions;

export default reducer;
